export default "__VITE_ASSET__DLz$vMiT__"